import { useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import BuilderService from '../services/BuilderService';
import { AxiosError } from 'axios';
import { useUpdateUserDetails } from '../../redux/hooks/UserDetails';

function DashboardProtected({ children }: { children: React.ReactNode }) {
  const { updateUserDetail } = useUpdateUserDetails();
  const builderService = new BuilderService();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const querytoken = queryParams.get('auth');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedUser = await builderService.getUser();
        if (fetchedUser && fetchedUser.data) {
          updateUserDetail(fetchedUser.data);
        }
      } catch (error) {
      }
    };
    
    fetchData();
  }, [updateUserDetail]);

  return <>{children}</>;
}

export default DashboardProtected;